<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="500" persistent>
      <template v-slot:activator="{ on }">
        <v-btn color="red lighten-2" dark v-on="on">store list</v-btn>
      </template>

      <v-card v-if="!isLoadingStore">
        <v-card-title class="headline">
          STORE LIST <v-divider vertical class="ml-3 mr-3"></v-divider>
          <v-spacer></v-spacer>
          <v-btn icon flat @click="$emit('close')"
            ><v-icon color="black">close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <v-list style="max-height: 600px; overflow: scroll">
            <v-list-tile
              v-for="(store, key) in storeList"
              :key="key"
              avatar
              ripple
            >
              <v-list-tile-content>
                <v-list-tile-title
                  >{{ store.store_name_th }}
                  <span style="font-size: 12px; color: #999999">
                    {{
                      store.store_name_en ? "(" + store.store_name_en + ")" : ""
                    }}</span
                  >
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon @click="$emit('delete')"
                  ><v-icon color="error">delete</v-icon></v-btn
                >
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>

      <v-card v-if="isLoadingStore"> Loading ... </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ["dialog", "storeList", "isLoadingStore"],
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
</style>